import React from 'react'
import CollectionMediaItem from './collection-item'
import { selectBestVimeoSource, selectBestVimeoPoster, httpsify } from '../../lib/vimeo_data_util'

import './collection-media.css'

// Get flattened list of all images sources
// by looping through all slides and media lists
const getAllImages = rows => {
  return rows
    .reduce((prev, curr) => {
      // Media list
      // row.get('slide_media)
      const media = curr.slide.get('slide_media')

      // Flatten for list of all images
      prev = prev.concat(media.reduce((p, c) => {
        p = p.concat(c)
        return p
      }, []))

      return prev
    }, [])
}

// Match src with point in image list to get index
const getImageIndex = (src, rows, size) => {
  let allImages = getAllImages(rows)
  allImages = getImageSources(allImages, size)
  return allImages.indexOf(src)
}

// Get sized images sources
const getImageSources = (images, size) => {
  return images.map(media => (
    // Special case for videos, use the uri 
    media.get('slide_video') ?
    media.getIn(['slide_video', 'uri']) : 
    // Otherwise return src of this image size
    media.getIn(['slide_image', 'sizes', size])
  ))
}

const getLightboxIndex = (item, rows, vw) => {
  const mediaType = item.get('media')
  const isVideo = mediaType === 'video'

  let src = ''

  if (isVideo) {
    src = item.get('slide_video') && item.getIn(['slide_video', 'uri'])
  } else {
    src = item.get('slide_image') && item.getIn(['slide_image', 'sizes', 'large'])
  }

  const index = getImageIndex(src, rows, 'large')
  return index + 1
}

const getImageSize = (item, size) => item.getIn(['slide_image', 'sizes', size])

// Image source determined by column span
// 1-4 = 512 = 'thumbnail'
// 5-10 = 1024 = 'medium'
// 11-18 = 1680 = 'large'
// 19-24 = 2048 = 'xlarge'
// If viewportWidth is mobile breakpoint
// Use the mobile image
const getImageSource = (item, mobileMedia, vw) => {

  if (vw < 667 && mobileMedia) {
    return mobileMedia
  }

  const colSpan = item.get('width')
  const slideImage = item.get('slide_image')

  if (!slideImage) return ''

  if (colSpan >= 19) {
    return getImageSize(item, 'xlarge')
  } else if (colSpan >= 11) {
    return getImageSize(item, 'large')
  } else if (colSpan >= 5) {
    return getImageSize(item, 'medium')
  } else {
    return getImageSize(item, 'thumbnail')
  }
}

const getVideoPosterSource = (item, vw) => {
  const mediaType = item.get('media')
  const isVideo = mediaType === 'video'
  const videoData = item.get('slide_video')

  if (isVideo && videoData) {
    const source = selectBestVimeoPoster(videoData.toJS())
    return httpsify(source.link)
  }

  return ''
}

const getIsVideo = (item) => {
  const mediaType = item.get('media')
  return mediaType === 'video'
}

const getVideoSource = (item, vw, disableFullVideo) => {
  const isVideo = getIsVideo(item)
  const videoDataRes = item.get('slide_video')

  if (isVideo && videoDataRes) {
    const mediaWidth = Math.max(480, item.get('width') * vw / 24)

    const source = selectBestVimeoSource(videoDataRes.toJS(), mediaWidth)
    return httpsify(source.link)
  }

  return ''
}

const getVideoImageWidth = item => {
  const mediaType = item.get('media')
  const isVideo = mediaType === 'video'
  const slideRef = isVideo ? 'slide_video' : 'slide_image'

  return item.get(slideRef) ? item.getIn([slideRef, 'width']) : 0
}
const getVideoImageHeight = item => {
  const mediaType = item.get('media')
  const isVideo = mediaType === 'video'
  const slideRef = isVideo ? 'slide_video' : 'slide_image'

  return item.get(slideRef) ? item.getIn([slideRef, 'height']) : 0
}

const CollectionMedia = ({
  id,
  slug,
  match,
  rowIndex,
  vw,
  vh,
  st,
  media,
  mobileMedia,
  disableFullVideo,
  rows,
  onImageEnter,
  onImageLeave }) => {
  return (
    <div className="collection__media">
      {media.map((item, index) => (
        <CollectionMediaItem
          id={id}
          slug={slug}
          match={match}
          rowIndex={rowIndex}
          vw={vw}
          vh={vh}
          st={st}
          key={index}
          index={index}
          lightboxIndex={getLightboxIndex(item, rows, vw)}
          imageSrc={getImageSource(item, mobileMedia, vw)}
          videoSrc={getVideoSource(item, vw, disableFullVideo)}
          videoPosterSrc={getVideoPosterSource(item, vw)}
          usePlayer={!disableFullVideo && getIsVideo(item) && !!item.get('slide_video') && !!item.get('slide_video_inline')}
          imageWidth={getVideoImageWidth(item)}
          imageHeight={getVideoImageHeight(item)}
          xOffset={item.get('slide_x_offset')}
          yOffset={item.get('slide_y_offset')}
          colSpan={item.get('width')}
          onImageEnter={onImageEnter}
          onImageLeave={onImageLeave} />
      ))}
    </div>
  )
}

export default CollectionMedia



// WEBPACK FOOTER //
// ./src/components/collection-media/index.js